import { useState } from "react"
/**
 * Like useState but keep persistent between refreshes
 *
 * @param {string} keyName - Must be unique for the whole app.
 * @param {any} defaultValue - works the same like for useState.
 * @param {boolean} skipLocalStorage - If true skip using localstorage.If false use default value

 */
export function useLocalStorage(keyName, defaultValue = undefined, skipLocalStorage = false) {
  function getDefaultValue() {
    if(localStorage[keyName] !== undefined &&
      localStorage[keyName] != "undefined" &&
      !skipLocalStorage){
        return JSON.parse(localStorage[keyName]);
    } 

    return defaultValue;
  }

  var [value, setValue] = useState(getDefaultValue())
  return [
    value,
    newValue => {
      localStorage[keyName] = JSON.stringify(newValue)
      setValue(newValue)
    },
  ]
}
